export default "__VITE_ASSET__nJkgIVJgL11RgZiGUBj6wA__";